'use strict';

var React = require('react');

var SvgTransferInternalIcon = function SvgTransferInternalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 3.5a2.75 2.75 0 0 0-2.75 2.75v7.5a2.75 2.75 0 0 0 2.75 2.75h7.5a2.75 2.75 0 0 0 2.75-2.75v-7.5a2.75 2.75 0 0 0-2.75-2.75h-7.5Zm-1.25 7h6.44l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06l1.22 1.22h-6.44v-2.75c0-.69.56-1.25 1.25-1.25h.5v2a.75.75 0 0 0 1.5 0v-2h5.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-5.5v-2a.75.75 0 0 0-1.5 0v2h-.5c-.69 0-1.25-.56-1.25-1.25v-3.25Z"
  }));
};
SvgTransferInternalIcon.displayName = "TransferInternalIcon";

exports.SvgTransferInternalIcon = SvgTransferInternalIcon;
